import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import TextSizeToggle from "./TextSizeToggle";
import { scrollToId } from "../lib/scroll";

const LINKS = [
    ["Why it matters", "why-it-matters"],
    ["For organizations", "organizations"],
    ["What you'll learn", "what-youll-learn"],
    ["How it works", "how-it-works"],
    ["About", "about"],
    ["FAQ", "faq"],
];

export default function Header() {
    const [open, setOpen] = useState(false);
    const go = (e, id) => {
        e.preventDefault();
        setOpen(false);
        // Scroll after the mobile menu unmounts, so the target position is final
        window.setTimeout(() => scrollToId(id), 80);
    };
    return (
        <header className="sticky top-0 z-50 border-b border-clay bg-cream/90 backdrop-blur-md">
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-5 sm:px-8 md:h-20">
                <a href="#top" data-testid="header-logo" onClick={(e) => go(e, "top")} aria-label="Fall Safe Ready — back to top">
                    <Logo />
                </a>
                <nav className="site-nav items-center" aria-label="Primary">
                    {LINKS.map(([label, id]) => (
                        <a
                            key={id}
                            href={`#${id}`}
                            data-testid={`header-link-${id}`}
                            onClick={(e) => go(e, id)}
                            className="text-lg font-semibold text-ink-soft transition-colors duration-200 hover:text-teal-700"
                        >
                            {label}
                        </a>
                    ))}
                </nav>
                <div className="flex items-center gap-3">
                    <a
                        href="/es"
                        data-testid="lang-switch-es"
                        className="lang-pill hidden h-12 items-center rounded-full border-2 border-ink px-4 text-base font-semibold text-ink transition-colors duration-200 hover:bg-ink hover:text-cream md:inline-flex"
                    >
                        ES
                    </a>
                    <TextSizeToggle />
                    <a href="#signup" data-testid="header-cta" onClick={(e) => go(e, "signup")} className="btn-primary hidden whitespace-nowrap md:inline-flex">
                        Join the interest list
                    </a>
                    <button
                        type="button"
                        className="menu-toggle inline-flex h-12 w-12 items-center justify-center rounded-full border border-clay bg-white text-ink lg:hidden"
                        data-testid="header-menu-toggle"
                        aria-expanded={open}
                        aria-controls="mobile-nav"
                        aria-label={open ? "Close menu" : "Open menu"}
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
                    </button>
                </div>
            </div>
            {open && (
                <div id="mobile-nav" className="border-t border-clay bg-cream px-5 pb-6 pt-2 lg:hidden">
                    <nav className="flex flex-col" aria-label="Mobile">
                        {LINKS.map(([label, id]) => (
                            <a
                                key={id}
                                href={`#${id}`}
                                data-testid={`header-mobile-link-${id}`}
                                onClick={(e) => go(e, id)}
                                className="border-b border-clay/60 py-3.5 text-lg font-semibold text-ink"
                            >
                                {label}
                            </a>
                        ))}
                    </nav>
                    <a href="#signup" data-testid="header-mobile-cta" onClick={(e) => go(e, "signup")} className="btn-primary mt-5 w-full">
                        Join the interest list
                    </a>
                </div>
            )}
        </header>
    );
}